<div class="container" *ngIf="permissionAccess">
    <div class="row">
        <div class="col-lg-12 mt-2 mb-2">
            <h1 class="text-center">Generar preapprovals mrpresta lending</h1>
        </div>
    </div>
    <hr>
    <div class="row" *ngIf="partners.length > 0">
        <div class="row mt-2 mb-2 mx-auto">
            <div class="col-lg-3">
    
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Desde</mat-label>
                    <input matInput [matDatepicker]="picker_from" placeholder="DD-MM-YYYY" value="dateSelected.from"
                        [(ngModel)]="dateSelected.from">
                    <mat-datepicker-toggle matSuffix [for]="picker_from"></mat-datepicker-toggle>
                    <mat-datepicker #picker_from disabled="false"></mat-datepicker>
                </mat-form-field>
    
            </div>
    
            <div class="col-lg-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Hasta</mat-label>
                    <input matInput [matDatepicker]="picker_to" placeholder="DD-MM-YYYY" [value]="dateSelected.to"
                        [(ngModel)]="dateSelected.to">
                    <mat-datepicker-toggle matSuffix [for]="picker_to"></mat-datepicker-toggle>
                    <mat-datepicker #picker_to disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-lg-3">
                <mat-form-field appearance="outline">
                    <mat-label>Select partner</mat-label>
                    <mat-select>
                        <mat-option [value]="partner.name" (click)="setPartner(partner)" *ngFor="let partner of partners">{{partner.view_name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-3">
                <p class="mt-3"><mat-slide-toggle [(ngModel)]="isRefill">{{isRefill ? 'refill   ' : 'merchants'}}</mat-slide-toggle></p>
            </div>
        </div>
    
        <div class="row mt-2 mb-2 mx-auto" *ngIf="dynamicForm">
            <div class="col-lg-12">
                <span class="text-muted">Separados por coma. Ej. merchant1,merchant2,merchant3</span>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Merchants a procesar</mat-label>
                    <textarea matInput [(ngModel)]="merchantsCaptured"></textarea>
                </mat-form-field>
            </div>
        </div>
    
        <div class="row mt-2 mb-2 mx-auto" *ngIf="dynamicForm">
            <form [formGroup]="dynamicForm" class="w-100 p-4">
                <ng-container *ngTemplateOutlet="formGroupTmp; context: { form: dynamicForm }"></ng-container>
            </form>
        </div>
    
        <mat-divider class="mt-2 mb-2"></mat-divider>
    
        <div class="row mx-auto" *ngIf="dynamicForm">
            <div class="col-12 d-flex flex-row-reverse" >
                <button (click)="view()" class="btn btn-success sticky-btn mb-2">Execute</button>
            </div>
        </div>
    
        <ng-template #formGroupTmp let-form="form">
    
            <div [formGroup]="form" class="row">
    
                <div *ngFor="let control of getControlNames(form)" [class]="importantJsonKeys.includes(control) ? 'col-12 a': (isNestedGroup(form, control) && !importantJsonKeys.includes(control)) ? 'col-sm-12 col-lg-6 b' : 'col-12 c'">
    
                    <div class="h6 col-12 main-border" *ngIf="importantJsonKeys.includes(control)">
                        Main Param: "{{control}}"
                        <div *ngFor="let descriptionInfo of descriptionKeys">
                            <p *ngIf="control == descriptionInfo.key" class="font-weight-light">{{descriptionInfo.description}}</p>
                            
                        </div>
                    </div>
    
                    <div class="h6 col-12 secondary-border" *ngIf="isNestedGroup(form, control) && !importantJsonKeys.includes(control)">
                        Child Param: "{{control}}"
                    </div>
    
                    <div *ngIf="isNestedGroup(form, control); else simpleControl" class="col-12 w-100">
                        <ng-container *ngTemplateOutlet="formGroupTmp; context: { form: form.get(control) }"></ng-container>
                    </div>
    
                    <ng-template #simpleControl class="col-sm-12 col-lg-3">
                        <mat-form-field  class="w-100" appearance="outline" style="padding: 10px;">
                            <mat-label>{{control}}</mat-label>
                            <input matInput [placeholder]="" class="w-100" [formControlName]="control" type="number">
                        </mat-form-field>
                    </ng-template>
    
                </div>
    
                <mat-divider class="mt-1 mb-4"></mat-divider>
    
            </div>
    
        </ng-template>
    </div>
</div>
<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>